import { departmentLink, legislativeItemLink, meetingBodyLink, meetingLink, userLink, } from './links.js';
import { legislativeItemSystemStatusValueLabels, meetingStatusValueLabels, } from './value-labels.js';
/**
 * Combination data source: Meetings x Agenda Items.
 * Item counts, composition, and workload per meeting. Tracks how many items are on each
 * agenda, average items per meeting, and workload trends over time.
 */
export const meetingAgendaWorkloadCube = {
    category: 'Meetings',
    description: 'Agenda items linked to their meetings with workload metrics, composition details, and trends.',
    label: 'Meeting Agenda Workload',
    question: 'How heavy is each meeting and how does workload shift over time?',
    bestFor: 'Crosses meetings with their agenda items — the only source that exposes per-meeting counts, composition breakdowns, and trend data side by side.',
    tags: ['Workload', 'Items per Meeting', 'Trends'],
    requiredModule: 'hasAgenda',
    measures: {
        'meeting_agenda_workload.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        // Meeting
        'meetings.title': { label: 'Meeting Title', link: meetingLink, type: 'string' },
        'meetings.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
        // Agenda Item
        'meeting_agenda_workload.item_number': { label: 'Item Number', type: 'string' },
        'legislative_items.code': {
            label: 'Legislative Item Number',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.full_title': {
            label: 'Item Title',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        'legislative_items.requesting_consent': { label: 'Consent Agenda', type: 'boolean' },
        'legislative_items.public_hearing': { label: 'Public Hearing', type: 'boolean' },
        // Type & Status
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        // Context
        'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'users.display_name': { label: 'Staff Contact', link: userLink, type: 'string' },
    },
    timeDimensions: {
        'meetings.date': { label: 'Meeting Date', type: 'date' },
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
    },
};
